import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Table } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg13 from "../../../assets/svg/svg13.svg";
import svg29 from "../../../assets/svg/svg29.svg";
import { Link, useNavigate } from "react-router-dom";
import {  fetchSubsidySource } from "../../../features/fetch/fetchSlice";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import SubsidySourceAdd from "./modal/SubsidySourceAdd";
import ConfirmModal from "../../../components/ConfirmModal";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import CardLoading from "../../../components/CardLoading";
import BreadCrumb from "../../../layout/BreadCrumb";

function SubsidySourceTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
 
  const {subsidySources,loading} =  useSelector((state)=>state.fetch)
  const { open, handleCancel, handleOpen } = useModalToggle();

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

 
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/flid/subsidySource/delete",
        subsidySourceId: prodd?.subsidySourceId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchSetupData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width:'10px',
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "subsidySourceName",
      sorter: (a, b) => a.subsidySourceName.localeCompare(b.subsidySourceName),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const onFinish = () => {};

 
  async function fetchSetupData() {
    await dispatch(
      fetchSubsidySource()
    );
  }

  useEffect(() => {
    fetchSetupData();
  }, []);

  if (loading) return <CardLoading />;
  return (
    <>
      <BreadCrumb breadcrumbs={[{ title: "Subsidy Source Setup" }]} />
      <div className="white_card mt-[1.25rem] flex-1 min-h-[80vh]">
        <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
          <div className="form-add-h">Subsidy Source Setup</div>
          <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
           
            <div className="w-[200px]">
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />{" "}
                <span className="ml-1">Add Subsidy Source</span>
              </button>
            </div>
          </div>
        </div>

        <div className="max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.75rem] w-full"
            scroll={{
              x: 'auto',
            }}
            rowKey={(record) => record?.subsidySourceId}
            columns={columns}
            dataSource={subsidySources}
            loading={loading}
            // pagination={{
            //   position: ["bottomRight"],
            //   current: pageIndex + 1,
            //   total: count,
            //   pageSize: pageSize,
            //   onChange: (page, size) => {
            //     setPageIndex(page - 1);
            //     setPageSize(size);
            //     fetchSetupData(page - 1, size);
            //   },
            //   showSizeChanger: false,
            //   hideOnSinglePage: true,
            // }}
          />
        </div>

        <SubsidySourceAdd
          isModalOpen={open}
          handleCancel={handleCancel}
          handleFetch={fetchSetupData}
          prodd={prodd}
        />

        <ConfirmModal
          open={openDelete}
          handleCancel={handleCloseDelete}
          handleSubmit={handleDelete}
          loading={loading}
          content="Are you sure you want perfom this action?"
          type="alert"
          btnTitle="Delete"
        />
      </div>
    </>
  );
}

export default SubsidySourceTable;
